import classNames from "classnames";
import { ButtonLink } from "components/ButtonLink";
import Favorites from "components/header/Favorites";
import AfreecaSearchBar from "components/header/search/AfreecaSearchBar";
import useWindowScrollY from "components/hook/useWindowScrollY";
import ModalWindow from "components/ModalWindow";
import ReactPopup from "components/popup/ReactPopup";
import { AFREECATV_URL, BEST_BJ_URL, JAVASCRIPT_VOID, PARTNER_BJ_URL } from "constant/config";
import { STYPE_HASHTAG, STYPE_MY_BOARD } from "constant/log";
import { NICKNAME_USER_ID, USER_ID } from "constant/search";
import { documentScrollTop, getLoginUrl, getLogoutUrl, isWebview, localStorageFactory, getAndroidCompareVersion, inAppStore, trackEvent } from "helpers";
import { fetchTitleBlind, fetchLiveBlind } from "actions/blind.action";
import { runNewStudio, startupStudio } from "libs/broadcast";
import { searchLog } from "libs/searchLogCollection";
import React, { useCallback, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import LoginArea from "./LoginArea";

export default function Header({ disableBackButton }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const [scrollTop] = useWindowScrollY();
    const { is_login, user_id, is_best_bj, is_partner_bj } = useSelector((state) => state.authenticationReducer);
    const { stationInfo, bjInfo = {} } = useSelector((state) => state.stationReducer);
    const [color, setColor] = useState("#71b3d9");
    const [toolTipShow, setToolTipShow] = useState(false);

    const { loading, data = {} } = stationInfo;
    const { channelart = {} } = bjInfo;
    const { station = {}, is_owner } = data;
    const { station_name = "", station_no, user_id: station_id, user_nick: station_nick } = station;
    const { keyword = "" } = useParams();
    const [showTopBanner, setshowTopBanner] = useState(false); //노출여부
    const [fixedTopBanner, setFixedTopBanner] = useState(true); //상단고정여부
    const [headerStyle, setHeaderStyle] = useState({});

    /**
     * GNB를 고정할지 여부
     */
    useEffect(() => {
        setFixedTopBanner(showTopBanner === false || scrollTop >= 50);
    }, [scrollTop, showTopBanner]);

    /**
     * GNB postion 스타일변경
     */
    useEffect(() => {
        setHeaderStyle(fixedTopBanner ? { position: "fixed", top: 0 } : { position: "absolute", top: 50 });
    }, [fixedTopBanner]);

    useEffect(() => {
        var m = document.createElement("meta");
        m.name = "theme-color";
        m.content = color;
        document.head.appendChild(m);
    }, [color]);

    /**
     * 채널아트 색상이 변경되면
     */
    useEffect(() => {
        if (channelart.color) {
            setColor(channelart.color);
        }
    }, [channelart]);
    
    /**
     * 캐치 툴팁 추가확인
     */
    useEffect(() => {
        const catchToolTip = localStorageFactory.getItem('catch_tooltip_state') || 0;
        if (catchToolTip !== 'off') {
            setToolTipShow(true);
        }
    }, [channelart]);

    /**
     * 로그인되었을때 스튜디오 실행
     */
    useEffect(() => {
        if (is_login === true) {
            //스튜디오 실행버튼으로 로그인이 되었으면 실행
            startupStudio();
        }
    }, [is_login]);

    const handleOpenStudio = useCallback(() => {
        window.open("https://dashboard.onlive.vn/index.php");
    }, []);
    
    const handleBtnToolTipCloseClick = useCallback(()=>{
        setToolTipShow(false);
        localStorageFactory.setItem('catch_tooltip_state','off');
    });

    const handleGoBack = useCallback(() => {
        if (isWebview && history.length <= 1) {
            window.close();
        } else if (history.length <= 1) {
            history.push(`/${global.bj_id}`);
        } else {
            history.goBack();
        }
    }, [history]);

    const handleTitleClick = useCallback(() => {
        history.push(`/${global.bj_id}`);
        documentScrollTop();
    }, [history]);

    const handleSearchMyBoard = useCallback(
        (userId) => (event) => {
            searchLog({ keyword: userId, filter: USER_ID, searchType: STYPE_MY_BOARD });
        },
        [],
    );

    const handleTopBannerClose = useCallback((show) => {
        setshowTopBanner(show);
    }, []);

    const handleTargetBlind = (title_no, blind_id, modalClose) => {
		if (!is_login) { 
            window.location = getLoginUrl();
        } else {
            // 신고하기 기능과 신고 후 삭제/차단 기능 분리
            // 이 방송국 숨기기
            if(window.confirm(t("cái này Trạm thu phát thông tin Bạn sẽ che giấu nó?"))) {
                (async (title_no, blind_id, modalClose) => {
                    // 블라인드 API 호출
                    await fetchTitleBlind(title_no, modalClose);

                    // LIVE 정보 확인 및 AOS func call
                    setTimeout(async () => {
                        await fetchLiveBlind(blind_id, true);
                    }, 300);
                    
                })(title_no, blind_id, modalClose);
                
            }
        }		
	}

    if (isMobile) {
        return (
            <header id="af-header" className={classNames({ "loading-header": loading })} style={{ position: "fixed" }}>
                <section className="title-section" style={{ backgroundColor: color }}>
                    {!disableBackButton && (
                        <div className="grid-start">
                            <button type="button" className="btn-back white" onClick={handleGoBack}>
                                <span>
                                    <Trans>Phía sau</Trans>
                                </span>
                            </button>
                        </div>
                    )}
                    <h1 className="bs-title">
                        <a href={JAVASCRIPT_VOID} onClick={handleTitleClick}>
                            {station_name}
                        </a>
                    </h1>
                    <div className="bs-util">
                        {is_login && isWebview && is_owner && (
                            <ModalWindow
                                classNames={{
                                    modal: "ui-pop-m bs-layer",
                                }}
                                trigger={
                                    <button type="button" className="btn-write">
                                        <Trans>Tạo bài viết</Trans>
                                    </button>
                                }
                            >
                                {(close) => (
                                    <div className="pop-body pop-gnb">
                                        <ButtonLink type="button" className="btn-write" to={`/${global.bj_id}/post/write`}>
                                            <Trans>Tạo bài viết</Trans>
                                        </ButtonLink>
            
                                        <button
                                            type="button"
                                            className="btn-upload"
                                            onClick={() => {
                                                    window.location.href = "onlive://vod/upload"; 
                                                    close();
                                                }
                                            }
                                        >
                                            <Trans>VOD tải lên</Trans>
                                        </button>
                                    </div>
                                )}
                            </ModalWindow>
                        )}
                        {is_login && !(isWebview && is_owner) && (
                            <ButtonLink type="button"
                                        className="btn-write"
                                        onClick={trackEvent("ho7mm5")}
                                        to={`/${global.bj_id}/post/write`}>
                                <span>
                                    <Trans>Tạo bài viết</Trans>
                                </span>
                            </ButtonLink>
                        )}
                        <ButtonLink type="button"
                                    className="btn-search"
                                    onClick={trackEvent("7c235e")}
                                    to={`/${global.bj_id}/search`}>
                            <span>Tìm kiếm</span>
                        </ButtonLink>
                        <ModalWindow
                            classNames={{
                                modal: "ui-pop-m bs-layer",
                            }}
                            trigger={
                                <button type="button" className="btn-login">
                                    <span>Thêm thông tin</span>
                                </button>
                            }
                        >
                            {(close) => (
                                <div className="pop-body pop-gnb">
                                    <ul>
                                        {!isWebview && (
                                            <li>
                                                <a href={AFREECATV_URL}>
                                                    <Trans>Trang chủ OnLive</Trans>
                                                </a>
                                            </li>
                                        )}
                                        {is_login && is_owner === false && (
                                            <li>
                                                <a href={`/${user_id}`}>
                                                    <Trans>Của tôi Đài phát sóng</Trans>
                                                </a>
                                            </li>
                                        )}
                                        {is_login && is_best_bj && (
                                            <li>
                                                <a href={BEST_BJ_URL} target="_blank">
                                                    <Trans>tốt nhấtBJ bảng ghi chú Phím tắt</Trans>
                                                </a>
                                            </li>
                                        )}
                                        {is_login && is_partner_bj && (
                                            <li>
                                                <a href={PARTNER_BJ_URL} target="_blank">
                                                    <Trans>cộng sựBJ bảng ghi chú Phím tắt</Trans>
                                                </a>
                                            </li>
                                        )}
                                        {is_login && (
                                            <li>
                                                <Link
                                                    type="button"
                                                    onClick={handleSearchMyBoard(user_id)}
                                                    to={{
                                                        pathname: `/${global.bj_id}/search`,
                                                        state: { searchType: STYPE_HASHTAG },
                                                        search: `keyword=${user_id}&field=${NICKNAME_USER_ID}`,
                                                    }}
                                                >
                                                    <Trans>Tạo bài viết của tôi</Trans>
                                                </Link>
                                            </li>
                                        )}
                                        {!is_owner && (
                                            <li>
                                                <ButtonLink
                                                    to={`/${global.bj_id}/report`}
                                                    state={{
                                                        common_idx: 0,
                                                        board_type: 206,
                                                        writer_id: station_id,
                                                        writer_nick: station_nick,
                                                        title: '',
                                                        is_report_station : true,
                                                    }}
                                                    isLogin={is_login}
                                                >
                                                    <span>
                                                        <Trans>Đài phát sóng Báo cáo</Trans>
                                                    </span>
                                                </ButtonLink>
                                            </li>
                                        )}
                                        {/* 방송국 차단하기 AOS 6.20.6 버전에서만 제공 - 모바일 */}
                                        {!is_owner && getAndroidCompareVersion("6.20.6") && (
                                            <li>
                                                <Link
                                                    type="button"
                                                    onClick={() => {handleTargetBlind(0, station_id, close)}}
                                                >
                                                <Trans>cái này Đài phát sóng Trốn</Trans>
                                                </Link>
                                            </li>
                                        )}
                                        
                                        {is_login && (
                                            <li>
                                                <a href={getLogoutUrl()}>
                                                    <Trans>Đăng xuất</Trans>
                                                </a>
                                            </li>
                                        )}
                                        {!is_login && (
                                            <li>
                                                <a href={getLoginUrl()}>
                                                    <Trans>Đăng nhập</Trans>
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </ModalWindow>
                    </div>
                </section>
            </header>
        );
    } else {
        return (
            <>
                <header id="af-header" className={classNames({ "loading-header": loading })} style={headerStyle}>
                    <div className="inner_header">
                        <h1>
                            <a href={AFREECATV_URL} alt="">
                                {""}
                            </a>
                        </h1>
                        {/* 검색 */}
                        <AfreecaSearchBar key={keyword} />
                        {/* //검색 */}
                        <div className="bs-util">
                            {is_login && (
                                <div className="bs-favor">
                                    <ReactPopup
                                        offsetX={6}
                                        trigger={
                                            <button type="button" className="favor" tip={t("Yêu thích")}>
                                                <span>
                                                    <Trans>Yêu thích</Trans>
                                                </span>
                                            </button>
                                        }
                                    >
                                        <Favorites />
                                    </ReactPopup>
                                </div>
                            )}
                            <div><a
                                href={`//stbbs.onlive.vn/vodupload/index.php?bj_id=${global.bj_id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none" }}
                            >
                                <button type="button" className="upload" tip={t("Tải lên VOD tại đây")}>
                                    <span>
                                        <Trans>Tải lên VOD tại đây</Trans>
                                    </span>
                                </button></a>
                                {toolTipShow && (
                                    <div id="FeedLayerToolTip" className="tooltip" style={{display: "block"}}>
                                        <p>
                                            <Trans>
                                            Tải lên video dọc<br/>ngắn hơn 60 giây<br/>và tận hưởng dịch vụ Catch nhé!
                                            </Trans>
                                        </p>
                                        
                                        <button type="button" className="close" onClick={handleBtnToolTipCloseClick}>
                                            닫기
                                        </button>
                                    </div>
                                )}
                            </div>
                            <button type="button" className="studio" tip={t("Quản lý phát sóng")} onClick={handleOpenStudio}>
                                <span>
                                    <Trans>Quản lý phát sóng</Trans>
                                </span>
                            </button>
                            <LoginArea />
                        </div>
                    </div>
                </header>
            </>
        );
    }
}
